<template>
  <!-- eslint-disable max-len -->
  <section>
    <div class="top-stripe"></div>
    <header class="header" ref="header">
      <div class="header__circle header__circle--pulse"></div>
      <div class="header__circle--bottom header__circle--bottom--pulse"></div>
      <div class="header__triangle header__triangle--rotate"></div>
      <div class="header__top-bar">
        <div class="top-bar__brand">
          <img src="../assets/logo.png" alt="Reccly" class="logo" @click="$refs.why_us.scrollIntoView({behavior: 'smooth'})">
        </div>
        <div class="top-bar__nav--mobile">
          <div class="nav__icon">
            <input class="icon__btn" type="checkbox" id="icon__icon" v-model="mobile_nav_open" :value="true"/>
            <label class="icon__icon" for="icon__icon"><span class="navicon"></span></label>
            <div class="list__wrapper">
              <ul class="top-nav__list" @click="mobile_nav_open = false">
                <li class="list__item">
                  HOME
                </li>
                <li class="list__item" @click="$refs.what_we_do.scrollIntoView({behavior: 'smooth', block: 'center'})">
                  OFERTA
                </li>
                <li class="list__item" @click="$refs.join_us.scrollIntoView({behavior: 'smooth', block: 'center'})">
                  WSPÓŁPRACA
                </li>
                <li class="list__item" @click="$refs.footer.scrollIntoView({behavior: 'smooth', block: 'center'})">
                  KONTAKT
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="top-bar__nav">
          <nav class="top-nav">
            <ul class="top-nav__list">
              <li class="list__item" @click="$refs.header.scrollIntoView({behavior: 'smooth'})">
                HOME
              </li>
              <li class="list__item" @click="$refs.what_we_do.scrollIntoView({behavior: 'smooth', block: 'center'})">
                OFERTA
              </li>
              <li class="list__item" @click="$refs.join_us.scrollIntoView({behavior: 'smooth', block: 'center'})">
                WSPÓŁPRACA
              </li>
              <li class="list__item" @click="$refs.footer.scrollIntoView({behavior: 'smooth', block: 'center'})">
                KONTAKT
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="header__content">
        <div class="content__row">
          <div class="row__left">
            <div class="left__wrapper">
              <h1>
                Poznaj reccly!
              </h1>
              <h2>
                Poprostu <span style="font-family: 'Gilroy Light', sans-serif;">skup się</span> na tym co kochasz,
                a <span style="font-family: 'Gilroy Light', sans-serif;">my</span> zajmiemy się resztą!
              </h2>
              <div class="wrapper__buttons">
                <button class="buttons__btn buttons__btn--primary buttons__btn--pulse"  @click="$refs.what_we_do.scrollIntoView({behavior: 'smooth', block: 'center'})">Nasza oferta</button>
                <button class="buttons__btn buttons__btn--secondary" @click="$refs.footer.scrollIntoView({behavior: 'smooth', block: 'center'})">Kontakt</button>
              </div>
            </div>
          </div>
          <div class="row__right">
            <img src="../assets/worker.png" alt="">
          </div>
        </div>
      </div>
      <div class="splash-1-light"></div>
      <div class="triangle triangle--rotate"></div>
      <div class="splash-1">
        <div class="splash__wrapper">
          <div class="splash" ref="tracking"></div>
        </div>
      </div>
    </header>
    <article class="cooperation" data-aos="slide-up">
      <div class="cooperation__mouse"></div>
      <p class="cooperation__title">
        Współpracowaliśmy z nimi i <span style="font-family: 'Gilroy Light', sans-serif;">jesteśmy</span> z tego dumni
      </p>
      <div class="cooperation__brands">
        <swiper class="brands-swiper" :options="brandsSwiperOption">
          <swiper-slide>
            <img src="../assets/brands/diablo.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/gbs.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/hiddenfrom.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/mercedes.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/sfd.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/tipply.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/tvp.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/zabka.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/brands/ytshore.png" alt="">
          </swiper-slide>
          <swiper-slide>
            <a href="https://www.weselezklasa.pl/reccly/" target="_blank" title="🎬 OSTATNIE TERMINY do -50%! ⭐Reccly • Jakość, doświadczenie i pasja❤️"><img src="../assets/brands/wzk.png" alt="🎬 OSTATNIE TERMINY do -50%! ⭐Reccly • Jakość, doświadczenie i pasja❤️"></a>
          </swiper-slide>
        </swiper>
      </div>
    </article>
    <article class="what-we-do" ref="what_we_do" id="what_we_do" data-aos="slide-up">
      <div class="what-we-do__circle--bottom what-we-do__circle--bottom--pulse"></div>
      <div class="what-we-do__triangle--bottom what-we-do__triangle--bottom--rotate"></div>
      <div class="what-we-do__circle what-we-do__circle--pulse"></div>
      <div class="what-we-do__triangle what-we-do__triangle--rotate"></div>
      <div class="what-we-do__splash--desktop"></div>
      <div class="what-we-do__title">
        <p class="title--muted">ZAPEWNE ZAPYTASZ</p>
        <p class="title--heading">Czym się zajmujemy?</p>
      </div>
      <div class="what-we-do__slider">
        <swiper class="swiper" :options="swiperOption">
        <swiper-slide>
            <img src="../assets/stronki.png" alt="">
            <div class="slide__info">Tworzenie stron internetowych</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/produkcja.png" alt="">
            <div class="slide__info">Produkcja filmów</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/montage.png" alt="">
            <div class="slide__info">Montaż filmów YouTube</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/graphic.png" alt="">
            <div class="slide__info">Oprawa Graficzna, Branding</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/stream.png" alt="">
            <div class="slide__info">Realizacje transmisji na żywo </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/weeeding.png" alt="">
            <div class="slide__info">Pamiątki okolicznościowe</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/pizza.png" alt="">
            <div class="slide__info">Tworzenie reklam</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/foto.png" alt="">
            <div class="slide__info">Fotografia</div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/ae.png" alt="">
            <div class="slide__info">Tworzenie animacji</div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" @click="$refs.swiper_button_prev_sub.click()"></div>
          <div class="swiper-button-next" slot="button-next" @click="$refs.swiper_button_next_sub.click()"></div>
        </swiper>
      </div>
      <div class="what-we-do__slider-info">
        <swiper class="swiper" :options="swiperOption2">
          <swiper-slide>
            <div class="slide__info">
              <p>Na życzenie jesteśmy w stanie zaprojektować oraz zaprogramować</p>
              <p>tak jak chcesz stronę bądź platformę internetową, </p>
              <p>sklep lub Twoją wizytówkę, a przy pomocy</p>
              <p>naszych programistów, spiąć wszystko w całość. </p>
              <p>Dzięki nim żadne wyzwanie nie jest dla nas trudne!</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Naszą główną specjalizacją, jest produkcja filmów </p>
              <p>krótkometrażowych, długometrażowych, reklam, promocji, </p>
              <p>teledysków, prezentacji, skrótów wydarzeń jak i wiele więcej. </p>
              <p>W tym temacie czujemy się jak ryba w wodzie. </p>
              <p>Korzystamy z wysokiej klasy sprzętu,</p>
              <p>którego jakość zadowoli najbardziej wymagających.</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Posiadamy ogromny bagaż doświadczeń w tym temacie, </p>
              <p>jak nie największy z dostępnych firm. </p>
              <p>Wspólnie współpracujemy z Polskimi Twórcami już od ponad 5 lat!</p>
              <p>Członkowie naszej firmy brali udział </p>
              <p>w ogromnych projektach polskiego Internetu</p>
              <p>co owocuje ogromnym doświadczeniem i wiedzą w tym temacie.</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>W świeżym i nowoczesnym stylu budujemy </p>
              <p>najpopularniejsze marki. Tworzymy szaty graficzne, </p>
              <p>przygotujemy posty reklamowe na socialmedia,</p>
              <p>a nawet prowadzimy usługę supportu utrzymując</p>
              <p>kontakt z Twoimi klientami w szybki i klarowny sposób.</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Jesteśmy w stanie przeprowadzić transmisję wideo na żywo </p>
              <p>z dowolnego miejsca w Polsce i na dowolnej platformie </p>
              <p>zapewniając jak najwyższą jakość transmisji. </p>
              <p>Dbamy o każdy szczegół, przygotowujemy oprawę </p>
              <p>graficzną a czasami i merytoryczną. Do usług.</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Poszukujesz osób z odpowiednim fachem do </p>
              <p>udokumentowania Twoich lub Twojej rodziny najważniejszych</p>
              <p>chwil w życiu? Trafiłeś wręcz idealnie. </p>
              <p>Posiadamy duże zaplecze sprzętu i doświadczenia w tym temacie.</p>
              <p>Zajmujemy się realizacją pamiątek ślubnych, </p>
              <p>komunii, chrzcin i wiele wiele innych!</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Zajmujemy się masową produkcją krótkich filmów </p>
              <p>prezentujących produkty, firmy, bądź branże wszelkiej maści.</p>
              <p>Realizujemy w sposób kompleksowy </p>
              <p>dostarczając produkcje gotowe do emisji </p>
              <p>w telewizji oraz w socialmediach. </p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Zdjęcia z najważniejszych chwil w życiu</p>
              <p>– to naprawdę bardzo ważna i przydatna pamiątka,</p>
              <p>która potrafi cieszyć oko przez bardzo długie lata. </p>
              <p>Dla chętnych jesteśmy również w stanie, wywołać fotografie</p>
              <p>w formie cyfrowej i/lub papierowej. </p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__info">
              <p>Na zamówienie tworzymy animacje według preferencji </p>
              <p>przedstawionych przez Ciebie w briefie. </p>
              <p>Stawiamy na jakość a zarazem przejrzystość opublikowanej animacji </p>
              <p>na Twoim fanpageu lub w innym źródle, zależnie</p>
              <p>od tego jaka ma być wskazana produkcja.</p>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev-sub" slot="button-prev" ref="swiper_button_prev_sub" style="opacity: 0;"></div>
          <div class="swiper-button-next-sub" slot="button-next" ref="swiper_button_next_sub" style="opacity: 0;"></div>
        </swiper>
      </div>
      <div class="splash-2"></div>
    </article>
    <article class="why-us" ref="why_us" data-aos="slide-up">
      <div class="why-us__content">
        <div class="content__left">
          <div class="left__title">
            <p class="title--muted">Dlaczego właśnie my?</p>
            <p class="title--heading">Realizujemy Twoje pomysły!</p>
          </div>
          <div class="left__info">
            <p class="info__text">
              Nie działamy szablonowo, stawiamy na świeże pomysły.
              Jesteśmy młodą, a zarazem zgraną ekipą
              z wieloletnim doświadczeniem w tej branży.
              Znamy oczekiwania i potrzeby naszych klientów,
              co daje nam oryginalne i indywidualne podejście do każdego klienta Reccly.
            </p>
          </div>
          <div class="left__yt" @click="showYt = true">
            <div class="yt__iframe" v-if="!showYt">

            </div>
            <div v-else>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/qza27M5TrfM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="content__right">
          <div class="yt__svg">

          </div>
          <div class="splash-3">
            <div class="splash__wrapper">
              <div class="splash" ref="tracking2"></div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <div ref="join_us" data-aos="slide-up">
      <div class="join-us__wave">
        <div class="splash join-us__splash">
          <p class="splash__title">reccly</p>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 250">
            <path fill="#171717" fill-opacity="1" d="M0,192L120,176C240,160,480,128,720,128C960,128,1200,160,1320,176L1440,192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
          </svg>
        </div>
      </div>
      <article class="join-us">
        <div class="join-us__bg">
          <div class="join-us__title">
            <div class="title__icon"></div>
            <p class="title--heading">
              Jak zacząć z nami współpracę?
            </p>
            <p class="title--subtitle">
              Dzielą nas tylko 3 kroki od sukcesu
            </p>
          </div>
        </div>
        <div class="join-us__content">
          <p class="splash__title--light">reccly</p>
          <div class="content__row">
            <div class="row__col">
              <div class="col__icon">
                <div class="col__icon--coffee"></div>
              </div>
              <div class="col__title">
                Najlepiej zacząć od poznania się
              </div>
              <div class="col__content">
                <p>
                  Kontakt online lub spotkanie przy kawie - bo dlaczego by nie? Luźne podejście od osób tak energicznych i otwartych ma naprawdę ogromny wpływ na jakość współpracy między nami.
                </p>
              </div>
            </div>
            <div class="row__col">
              <div class="col__icon">
                <div class="col__icon--brain"></div>
              </div>
              <div class="col__title">
                Burza mózgów, wymiana pomysłów kompromisy
              </div>
              <div class="col__content">
                <p>
                  Jaką masz wizję swojego projektu? Postaramy się ją odwzorować najlepiej
                  jak tylko jest to możliwe i dołożymy coś od siebie, chyba że... pomysłów brak? Bez obaw! Jeśli trzeba, przygotujemy wszystkie niezbędne elementy
                  aby efekt naszej pracy cieszył oko przez naprawdę długi czas...
                </p>
              </div>
            </div>
            <div class="row__col">
              <div class="col__icon">
                <div class="col__icon--trophy"></div>
              </div>
              <div class="col__title">
                Sukces! Oglądanie efektu finalnego
              </div>
              <div class="col__content">
                <p>To zdecydowanie najlepszy etap! Przedstawiamy Ci gotowy materiał, wprowadzamy ewentualne poprawki i cieszymy się wspólnym sukcesem, wyprodukowanego materiału.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="join-us__arrow-wrapper">
          <button class="arrow-wrapper__btn" v-on:click="goto('https://www.facebook.com/recclypl')">Zamów swoje zlecenie</button>
          <div class="arrow-wrapper__arrow" @click="$refs.influencers.scrollIntoView({behavior: 'smooth'})">

          </div>
        </div>
      </article>
      <div class="join-us__bottom-wave">
        <div class="splash">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#171717" fill-opacity="1" d="M0,192L34.3,213.3C68.6,235,137,277,206,256C274.3,235,343,149,411,122.7C480,96,549,128,617,165.3C685.7,203,754,245,823,234.7C891.4,224,960,160,1029,128C1097.1,96,1166,96,1234,133.3C1302.9,171,1371,245,1406,282.7L1440,320L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path>
          </svg>
        </div>
        <div class="splash__right"></div>
        <div class="splash__left"></div>
      </div>
    </div>
    <article class="influencers" ref="influencers" data-aos="slide-up">
      <div class="influencers-splash"></div>
      <div class="influencers__title">
        <p class="title--muted">
          INFLUEN$ERZY
        </p>
        <p class="title--heading">
          Zaufali nam<br/>najwięksi
        </p>
      </div>
      <div class="influencers__slider">
        <swiper class="influencers__swiper" :options="influencersSwiperOption">
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/nester.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  NESTER
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/budda.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  BUDDA.TV
                </p>
                <p class="title--muted">
                  Motorization
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/medusa.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  MEDUSA
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/mołtalciopl.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  MORTALCIO
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/jurkiewicz_gbs.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  MATEUSZ JURKIEWICZ
                </p>
                <p class="title--muted">
                  Businessman
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/kubus1.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  HIDDENFROM
                </p>
                <p class="title--muted">
                  Music
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/wika.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  KARTONII
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/pacio.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  PACIO
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/patrtyk.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  FAME NEWS
                </p>
                <p class="title--muted">
                  News & Sport
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/vandal.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  VANDAL
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/adamz1.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  ADAMZ
                </p>
                <p class="title--muted">
                  Gaming
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/rafon.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  RAFONIX
                </p>
                <p class="title--muted">
                  Gaming
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slider__slide">
              <div class="slide__img">
                <img src="../assets/influencers/boxdel.png" alt="">
              </div>
              <div class="slide__title">
                <p class="title--heading">
                  BOXDEL
                </p>
                <p class="title--muted">
                  Lifestyle
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <div class="slide__shadow"></div>
      </div>
      <div class="influencers__info">
        <div class="info__projects">
          <div class="projects__bg"></div>
          <div class="projects__top-icons">
            <div class="top-icons__heart-left top-icons__heart-left--pulse"></div>
            <div class="top-icons__heart-right top-icons__heart-right--pulse"></div>
            <div class="top-icons__like-left top-icons__like-left--pulse"></div>
            <div class="top-icons__like-right top-icons__like-right--pulse"></div>
          </div>
          <div class="projects__bottom-icons">
            <div class="bottom-icons__like-left bottom-icons__like-left--pulse"></div>
            <div class="bottom-icons__heart-right bottom-icons__heart-right--pulse"></div>
          </div>
          <p class="projects__count">
            44
          </p>
          <p class="projects__title">
            Zrealizowanych<br/>projektów
          </p>
        </div>
        <div class="info__content">
          <div class="content__left">
            <p>Mieliśmy okazję współpracować, z najbardziej znanymi postaciami
              Polskiego internetu jak i ogromnymi markami,
              które bardzo chętnie korzystają z
              śwadczonych przez nas usług aż do dzisiaj.</p>
          </div>
          <div class="content__right">
            <p>Czas który spędziliśmy na planie, wyeliminował nasze słabe strony oraz znacznie podniósł nasze doświadczenie. Dzięki temu zawdzięczamy miejsce,
              w którym aktualnie się znajdujemy.</p>
          </div>
        </div>
        <div class="hours">
          <div class="hours__watch"></div>
          <div class="hours__calendar"></div>
          <div class="hours__sandglass"></div>
          <p class="hours__count">
            386h
          </p>
          <p class="hours__title">
            Czas spędzony na planie filmowym
          </p>
        </div>
      </div>
    </article>
    <footer class="footer" ref="footer" data-aos="slide-up">
      <div class="splash" style="font-size: 0;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#171717" fill-opacity="1" d="M0,160L48,170.7C96,181,192,203,288,181.3C384,160,480,96,576,96C672,96,768,160,864,186.7C960,213,1056,203,1152,170.7C1248,139,1344,85,1392,58.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <div class="hours">
          <div class="hours__watch"></div>
          <div class="hours__calendar"></div>
          <div class="hours__sandglass"></div>
          <div class="hours__count--bg--dark">386</div>
          <p class="hours__count">
            386h
          </p>
          <p class="hours__title">
            Czas spędzony<br/>na planie<br/>filmowym
          </p>
        </div>
      </div>
      <div class="footer__content">
        <div class="content__row">
          <div class="row__left">
            <div class="left__wrapper">
              <div class="left__smile"></div>
              <p class="left--muted">
                A więc jak..?
              </p>
              <p class="left--heading">
                Stworzymy coś?<br/>
                Napisz do nas!
              </p>
              <p class="left__contact">
                <span class="contact--primary">EMAIL</span><span>studio@reccly.pl</span><br/>
                <span class="contact--primary">TELEFON</span><span>+48 515 991 639</span>
              </p>
              <div class="left__social-media">
                <button class="social-media__icon" v-on:click="goto('https://www.facebook.com/recclypl')">
                  <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="-80 0 512 512"><path fill="#171717" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>
                </button>
                <button class="social-media__icon" v-on:click="goto('https://www.instagram.com/recclypl')">
                  <svg xmlns="http://www.w3.org/2000/svg" focusable="false" viewBox="0 0 512 512"><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
                </button>
                <button class="social-media__icon" v-on:click="goto('https://www.youtube.com/channel/UCxqQGLSCkyCi_fLZkrV8Eog')">
                  <svg xmlns="http://www.w3.org/2000/svg" focusable="false" viewBox="0 0 576 512"><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/></svg>
                </button>
              </div>
              <div class="left__messenger left__messenger--pulse" v-on:click="goto('https://www.facebook.com/recclypl')">
                WIADOMOŚĆ MESSENGER
              </div>
            </div>
          </div>
          <div class="row__right">
            <div class="right__img">
              <img src="../assets/footer.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
  import Vue from 'vue';
  import VueFbCustomerChat from 'vue-fb-customer-chat';
  import VueGtag from 'vue-gtag';
  import axios from 'axios';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';

  Vue.use(VueFbCustomerChat, {
    page_id: 105227031066719, //  change 'null' to your Facebook Page ID,
    theme_color: '#0084ff', // theme color in HEX
    locale: 'pl_PL', // default 'en_US'
    logged_in_greeting: 'Witaj, jak możemy ci pomóc?',
    logged_out_greeting: 'Witaj, jak możemy ci pomóc?',
  });

  Vue.use(VueGtag, {
    config: { id: 'UA-112779010-1' },
  });

  export default {
    name: 'Homepage',
    components: {
      Swiper,
      SwiperSlide,
    },
    watch: {
      mobile_nav_open: {
        handler() {
          document.body.classList.toggle('menu-open');
        },
      },
    },
    data() {
      return {
        mobile_nav_open: false,
        showYt: false,
        swiperOption: {
          effect: 'coverflow',
          centeredSlides: true,
          slidesPerView: 'auto',
          initialSlide: 1,
          allowTouchMove: false,
          observer: true,
          observeParents: true,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperOption2: {
          effect: 'coverflow',
          centeredSlides: true,
          slidesPerView: 'auto',
          initialSlide: 1,
          allowTouchMove: false,
          observer: true,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          observeParents: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          },
          navigation: {
            nextEl: '.swiper-button-next-sub',
            prevEl: '.swiper-button-prev-sub',
          },
        },
        influencersSwiperOption: {
          slidesPerView: 5,
          spaceBetween: 50,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          loop: true,
          observer: true,
          observeParents: true,
          uniqueNavElements: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          breakpoints: {
            1569: {
              slidesPerView: 4,
              spaceBetween: 60,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
          },
        },
        brandsSwiperOption: {
          spaceBetween: 50,
          observer: true,
          observeParents: true,
          uniqueNavElements: true,
          loop: true,
          loopAdditionalSlides: 30,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          breakpoints: {
            1569: {
              slidesPerView: 6,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            320: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
          },
        },
      };
    },
    methods: {
      moveSplash(e) {
        const splash = this.$refs.tracking;
        const splash2 = this.$refs.tracking2;
        let x = ((e.clientX * 100) / (window.innerWidth));
        let y = ((e.clientY * 100) / (window.innerHeight));
        x = `${x / 50}%`;
        y = `${y / 50}%`;
        splash.style.left = x;
        splash.style.top = y;
        splash.style.transform = `translate(${x}, ${y})`;
        splash2.style.left = x;
        splash2.style.top = y;
        splash2.style.transform = `translate(${x}, ${y})`;
      },
      login() {
        this.$gtag.event('login', { method: 'Google' });
      },
      goto(site) {
        window.open(site, '_blank');
      },
      countVisit() {
        axios.get('https://reccly.pl/addView.php');
      },
    },
    beforeMount() {
      this.countVisit();
    },
    mounted() {
      document.addEventListener('mousemove', this.moveSplash);
    },
  };
</script>

<style scoped lang="scss">
  $primary: #fe3c53;
  $dark: #1c1830;
  $light: #efefef;
  $assets: '~@/assets/';

  // Small tablets and large smartphones (landscape view)
  $screen-sm-min: 576px;

  // Small tablets (portrait view)
  $screen-md-min: 768px;

  // Tablets and small desktops
  $screen-lg-min: 992px;

  // Large tablets and desktops
  $screen-xl-min: 1200px;

  $screen-xxl-min: 1600px;

  // Small devices
  @mixin sm {
    @media (min-width: #{$screen-sm-min}) {
      @content;
    }
  }

  // Medium devices
  @mixin md {
    @media (min-width: #{$screen-md-min}) {
      @content;
    }
  }

  // Large devices
  @mixin lg {
    @media (min-width: #{$screen-lg-min}) {
      @content;
    }
  }

  // Extra large devices
  @mixin xl {
    @media (min-width: #{$screen-xl-min}) {
      @content;
    }
  }

  @mixin xxl {
    @media (min-width: #{$screen-xxl-min}) {
      @content;
    }
  }

  ::v-deep button, ::v-deep div.swiper-button-next, ::v-deep div.swiper-button-prev {
    outline: none !important;
  }

  .top-stripe {
    width: 100vw;
    height: 5px;
    background-color: $primary;
  }

  .header {
    position: relative;
    padding-top: 45px;
    background: url('../assets/mobile-splash_1.svg') no-repeat right;
    background-size: contain;
    max-width: 1200px;

    @include xl {
      &__circle {
        position: absolute;
        top: 12%;
        left: 30%;
        width: 44px;
        height: 44px;
        background: url('../assets/header-circle.svg') no-repeat center;
        background-size: cover;

        &--pulse {
          -webkit-animation: pulse-circle 2s cubic-bezier(.37,.29,.11,.92) infinite;
          animation: pulse-circle 2s cubic-bezier(.37,.29,.11,.92) infinite;
          @keyframes pulse-circle {
            0% {
              transform: scale(0.5);
              opacity: 0;
            }
            50% {
              opacity: 0.75;
            }
            70% {
              opacity: 0.35;
            }
            100% {
              transform: scale(1.3);
              opacity: 0;
            }
          }
        }

        &--bottom {
          position: absolute;
          left: 15%;
          width: 44px;
          height: 44px;
          background: url('../assets/header-circle.svg') no-repeat center;
          background-size: cover;
          bottom: 0;

          &--pulse {
            animation-delay: 2s;
            -webkit-animation: pulse-circle-bottom  3s cubic-bezier(.37,.29,.11,.92) infinite;
            animation: pulse-circle-bottom  3s cubic-bezier(.37,.29,.11,.92) infinite;
            @keyframes pulse-circle-bottom {
              0% {
                transform: scale(0.5);
                opacity: 0;
              }
              50% {
                opacity: 0.75;
              }
              70% {
                opacity: 0.35;
              }
              100% {
                transform: scale(1.3);
                opacity: 0;
              }
            }
          }
        }
      }

      &__triangle {
        position: absolute;
        top: 22%;
        left: 40%;
        width: 36px;
        height: 36px;
        background: url('../assets/header-triangle.svg') no-repeat center;
        background-size: cover;

        &--rotate {
          -webkit-animation:spin 10s linear infinite;
          -moz-animation:spin 10s linear infinite;
          animation:spin 10s linear infinite;

          @keyframes spin {
            100% {
            -webkit-transform: rotate(360deg); transform:rotate(360deg);
            }
          }
        }
      }
      background: none;
      margin: 60px auto 0 auto;
      padding-top: 0;
    }

    @include xl {
      padding-left: 30px;
      padding-right: 30px;
      max-width: 1569px;
    }

    &__top-bar {
      display: flex;
      justify-content: space-between;

      .top-bar__brand {
        margin-left: 34px;
        @include xl {
          margin-left: 0;
        }
        .logo {
          cursor: pointer;
          width: 133px;
          height: auto;
          transition: transform 0.3s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }

      .top-bar__nav--mobile {
        padding-right: 15px;
        @include md {
          display: none;
        }

        .icon__icon {
          cursor: pointer;
          display: inline-block;
          float: right;
          padding: 20px 20px;
          position: relative;
          user-select: none;
        }

        .icon__icon .navicon {
          background: #333;
          display: block;
          height: 5px;
          border-radius: 1rem;
          position: relative;
          z-index: 20;
          transition: background .2s ease-out;
          width: 25px;
        }

        .icon__icon .navicon:before,
        .icon__icon .navicon:after {
          border-radius: 1rem;
          background: #333;
          content: '';
          display: block;
          height: 100%;
          position: absolute;
          transition: all .2s ease-out;
          width: 100%;
        }

        .icon__icon .navicon:before {
          right: 0;
          width: 60%;
          top: 8px;
        }

        .icon__icon .navicon:after {
          top: -8px;
        }

        .icon__btn {
          display: none;
        }

        .list__wrapper {
          margin: 0 !important;
          position: fixed;
          top: -100vh;
          left: 0;
          width: 100vw;
          height: 100vh;
          overflow-y: hidden;
          background-color: #171717;
          transition: top .2s ease-out;
          display: flex;
          align-items: center;
          z-index: 19;
          ul {
            list-style-type: none;
            li {
              cursor: pointer;
              padding: 1.5rem 2rem 1.5rem 0;
              text-transform: uppercase;
              font-weight: bolder;
              font-family: 'Poppins-SemiBold', sans-serif;
              color: $light;
              font-size: 1.5rem;
            }
          }
        }

        .icon__btn:checked ~ .list__wrapper {
          top: 0;
        }

        .icon__btn:checked ~ .icon__icon .navicon {
          background: transparent;
        }

        .icon__btn:checked ~ .icon__icon .navicon:before {
          width: 100%;
          transform: rotate(-45deg);
          background-color: $primary;
        }

        .icon__btn:checked ~ .icon__icon .navicon:after {
          transform: rotate(45deg);
          background-color: $primary;
        }

        .icon__btn:checked ~ .icon__icon:not(.steps) .navicon:before,
        .icon__btn:checked ~ .icon__icon:not(.steps) .navicon:after {
          top: 0;
        }
      }

      .top-bar__nav {
        display: none;
        @include xl {
          display: initial;
        }

        .top-nav {
          &__list {
            list-style-type: none;
            display: flex;
            margin: 0;
            padding: 0;

            .list__item {
              cursor: pointer;
              padding: 17px 32px;
              text-transform: uppercase;
              font-weight: bolder;
              font-family: 'Poppins-SemiBold', sans-serif;
              color: $dark;
              font-size: 1.125rem;
              &:hover {
                color: $primary;
                &::after {
                  width: 100%;
                }
              }
              &::after {
                content: '';
                display: block;
                width: 0;
                height: 2px;
                background: $primary;
                transition: width .3s;
              }
            }

            :last-child {
              padding-right: 0;
            }
          }
        }
      }
    }

    &__content {
      .content__row {
        display: grid;
        grid-template-columns: 100%;
        grid-template-areas: "header-content-left"
                              "header-content-right";
        padding-top: 2rem;
        @include xl {
          margin: 0;
        }

        @include md {
          grid-template-columns: 50% 50%;
          grid-template-areas: "header-content-left header-content-right";
        }

        @include xxl {
          grid-template-rows: 750px;
        }

        .row__left {
          grid-area: header-content-left;
          padding: 0 30px;
          @include xl {
            padding: 0;
          }

          .left__wrapper {
            max-width: 564px;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;

            h1 {
              font-family: 'Gilroy-ExtraBold', sans-serif;
              font-size: 3.25rem;
              @include xl {
                font-size: 5.25rem;
              }
              font-weight: bold;
              margin: 0;
              margin-bottom: 20px;
              color: $dark;
            }

            h2 {
              font-family: 'Gilroy-ExtraBold', sans-serif;
              font-size: 1.25rem;
              font-weight: bold;
              margin: 0;
              margin-bottom: 34px;
              max-width: 270px;
              @include xl {
                max-width: 100%;
                font-size: 2rem;
              }
              color: $dark;
            }

            .wrapper__buttons {

              .buttons__btn {
                transition: transform 0.3s;
                &:hover {
                  transform: scale(1.1);
                }
                margin-right: 0;
                padding: 15px 25px;
                @include xl {
                  margin-right: 21px;
                  padding: 22px 52px;
                }
                border-radius: 4em;
                background-color: white;
                border: 2px solid $primary;
                font-size: 1.1rem;
                @include xl {
                  font-size: 1.3rem;
                }
                cursor: pointer;
                margin-bottom: .5rem;
                @include lg {
                  margin-bottom: 0;
                }

                &--primary {
                  background-color: $primary;
                  color: white;
                  margin-right: 1rem;
                  @include xl {
                    margin-right: 44px;
                  }
                }

                &--pulse {
                  -webkit-animation: pulse 2s cubic-bezier(.37,.29,.11,.92) infinite;
                  animation: pulse 2s cubic-bezier(.37,.29,.11,.92) infinite;
                  @keyframes pulse {
                    0% {
                      box-shadow: 0 0 0 0 rgba(247,1,47,.3);
                    }
                    100% {
                      box-shadow: 0 0 0 25px rgba(247,1,47,0);
                    }
                  }
                }

                &--secondary {
                  color: $primary;
                }
              }
            }
          }
        }

        .row__right {
          grid-area: header-content-right;
          display: flex;
          align-items: center;
          margin-top: 4rem;

          img {
            width: 103%;

            @include md {
              width: 100%;
            }

            @include lg {
              width: 80%;
            }

            @include xl {
              width: auto;
            }
          }
        }
      }
    }
  }

  .cooperation {
    margin: 93px auto 0 auto;
    position: relative;
    @include xl {
      padding: 0 30px;
    }
    max-width: 1569px;
    padding: 30px;

    &__mouse {
      display: none;
      width: 25px;
      height: 40px;
      position: absolute;
      @include lg {
        display: initial;
        right: 45%;
        bottom: 55%;
      }
      @include xxl {
        display: initial;
        right: 45%;
        bottom: 55%;
      }
      z-index: 10;
      background: url('../assets/mouse.png') no-repeat center;
    }

    &__title {
      font-size: 2rem;
      @include xl {
        max-width: 35%;
        font-size: 2.8rem;
      }
      color: $dark;
      font-family: 'Gilroy-ExtraBold', sans-serif;
      @include xl {
        padding: 95px;
      }
      margin: 0;
      margin-bottom: 1.5rem;
      @include xl {
        margin: 0;
      }
    }

    &__brands {
      width: 100%;
      @include xl {
        width: 800px;
      }
      height: 150px;
      border: 1px solid $light;
      background-color: white;
      border-radius: 5em;
      overflow: hidden;

      .brands-swiper {
        height: 100%;

        .swiper-slide {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .splash-1 {
    position: absolute;
    top: 93px;
    left: 0;
    height: 1140px;
    z-index: -1;
    width: 1330px;
    transform: translateX(73.5%);
    .splash__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      .splash {
        background: url('../assets/splash_3.svg') no-repeat;
        height: 100%;
        width: 100%;
      }
    }
  }

  .splash-1-light {
    display: none;
    @include md {
      display: initial;
    }
    position: absolute;
    top: -60px;
    left: 0;
    width: 1390px;
    z-index: -1;
    height: 1037px;
    background: url('../assets/splash_3_light.png') no-repeat;
  }

  .triangle {
    display: none;
    @include md {
      display: initial;
    }
    position: absolute;
    bottom: -400px;
    left: 0;
    width: 418px;
    z-index: -2;
    height: 437px;
    background: url('../assets/triangle.png') no-repeat;
    &--rotate {
      -webkit-animation:spin 10s linear infinite;
      -moz-animation:spin 10s linear infinite;
      animation:spin 10s linear infinite;

      @keyframes spin {
        100% {
          -webkit-transform: rotate(360deg); transform:rotate(360deg);
        }
      }
    }
  }

  .what-we-do {
    position: relative;
    padding: 0 30px;
    padding-bottom: 4rem;

    @include xxl {
      &__circle {
        position: absolute;
        top: 5%;
        right: 20%;
        &--bottom {
          position: absolute;
          bottom: 15%;
          left: 16%;
          width: 44px;
          height: 44px;
          background: url('../assets/header-circle.svg') no-repeat center;
          background-size: cover;

          &--pulse {
            -webkit-animation: pulse-circle 2s cubic-bezier(.37, .29, .11, .92) infinite;
            animation: pulse-circle 2s cubic-bezier(.37, .29, .11, .92) infinite;
            animation-delay: 4s;
            @keyframes pulse-circle {
              0% {
                transform: scale(0.5);
                opacity: 0;
              }
              50% {
                opacity: 0.75;
              }
              70% {
                opacity: 0.35;
              }
              100% {
                transform: scale(1.3);
                opacity: 0;
              }
            }
          }
        }
        width: 44px;
        height: 44px;
        background: url('../assets/header-circle.svg') no-repeat center;
        background-size: cover;

        &--pulse {
          -webkit-animation: pulse-circle 2s cubic-bezier(.37, .29, .11, .92) infinite;
          animation: pulse-circle 2s cubic-bezier(.37, .29, .11, .92) infinite;
          @keyframes pulse-circle {
            0% {
              transform: scale(0.5);
              opacity: 0;
            }
            50% {
              opacity: 0.75;
            }
            70% {
              opacity: 0.35;
            }
            100% {
              transform: scale(1.3);
              opacity: 0;
            }
          }
        }
      }

      &__triangle {
        position: absolute;
        top: 10%;
        right: 13%;
        width: 36px;
        height: 36px;
        background: url('../assets/header-triangle.svg') no-repeat center;
        background-size: cover;

        &--bottom {
          position: absolute;
          bottom: 20%;
          left: 9%;
          width: 36px;
          height: 36px;
          background: url('../assets/header-triangle.svg') no-repeat center;
          background-size: cover;

          &--rotate {
            -webkit-animation:spin 10s linear infinite;
            -moz-animation:spin 10s linear infinite;
            animation:spin 10s linear infinite;
            animation-delay: 2s;

            @keyframes spin {
              100% {
                -webkit-transform: rotate(360deg); transform:rotate(360deg);
              }
            }
          }
        }

        &--rotate {
          -webkit-animation:spin 10s linear infinite;
          -moz-animation:spin 10s linear infinite;
          animation:spin 10s linear infinite;

          @keyframes spin {
            100% {
              -webkit-transform: rotate(360deg); transform:rotate(360deg);
            }
          }
        }
      }
    }

    &__splash {
      &--desktop {
        display: none;
        @include xxl {
          position: absolute;
          top: 170px;
          left: 0;
          z-index: 3;
          width: 275px;
          height: 609px;
          background: url('../assets/what-we-do-splash-desktop.svg') no-repeat center;
          display: initial;
        }
      }
      &--left {
        position: absolute;
        top: 500px;
        z-index: -1;
        left: -40px;
        @include xxl {
          left: 0;
          display: none;
        }
        height: 550px;
        width: 109px;
        background: url('../assets/what-we-do-splash-left.svg') no-repeat center;
      }
      &--right {
        position: absolute;
        top: 0;
        z-index: -1;
        right: -40px;
        @include xxl {
          right: 0;
          display: none;
        }
        height: 926px;
        width: 109px;
        background: url('../assets/what-we-do-splash-right.svg') no-repeat center;
      }
    }
    @include xl {
      background: none;
    }

    &__title {
      background: url('../assets/question-mark.svg') no-repeat center;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 65px 0;

      .title--muted {
        color: $primary;
        font-size: 1.3rem;
        margin: 0;
        margin-top: 1em;
        padding: 0;
        font-family: 'Gilroy-Light', sans-serif;
        letter-spacing: 4px;
        text-align: center;
      }

      .title--heading {
        margin: 0;
        padding: 0;
        color: $dark;
        font-size: 2.8rem;
        font-family: 'Gilroy-ExtraBold', sans-serif;
        text-align: center;
      }
    }

    .what-we-do__slider {
      max-width: 1549px;
      margin: 0 auto;
      height: 210px;
      @include md {
        height: 410px;
      }
      width: 100%;

      @include xl {
        padding-top: 50px;
        padding-bottom: 50px;
      }

      .swiper {
        height: 100%;
        width: 100%;

        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          @include md {
            width: 720px;
            height: 410px;
          }
          text-align: center;
          font-weight: bold;
          font-size: 16 * 2;
          color: white;
          position: relative;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          .slide__info {
            position: absolute;
            border-radius: 4rem;
            font-size: 1rem;
            @include md {
              font-size: 2rem;
            }
            padding: 1rem 0;
            font-family: 'Gilroy-ExtraBold', sans-serif;
            width: 80%;
            left: 10%;
            bottom: 10%;
            background-color: rgba(13, 13, 13, .75);
            color: white;
            text-align: center;
            z-index: 2;
          }

          &.swiper-slide-prev {
            .swiper-slide-shadow-left {
              -webkit-mask-image: -webkit-gradient(linear, left top, left bottom,
                  from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
            }
          }

          /deep/ &.swiper-slide-prev {
            opacity: .25;

            .swiper-slide-shadow-left, .swiper-slide-shadow-right {
              border-radius: 2em;
            }
          }

          /deep/ &.swiper-slide-next {
            opacity: .25;

            .swiper-slide-shadow-left, .swiper-slide-shadow-right {
              border-radius: 2em;
            }
          }
        }

        .swiper-pagination {
          /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
            background-color: white;
          }
        }

        .swiper-button-prev, .swiper-button-next {
          color: $primary;
        }

        @include xl {
          .swiper-button-prev {
            left: 15%;
          }

          .swiper-button-next {
            left: 85%;
          }

        }

        .swiper-button-next, .swiper-button-prev {
          background-color: $primary;
          width: 3em;
          height: 3em;
          border-radius: 100%;
          color: white;

          &::after {
            font-size: 1.25rem !important;
          }
        }
      }
    }

    .what-we-do__slider-info {
      max-width: 1549px;
      margin: 0 auto;
      width: 100%;

      .swiper {
        height: 100%;
        width: 100%;

        .swiper-slide {
          width: 100%;
          @include xl {
            width: 720px;
          }
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-weight: bold;
          font-size: 16 * 2;
          color: white;
          position: relative;
          .slide__info {
            margin: 65px 0;

            p {
              text-align: center;
              color: $dark;
              font-size: 1rem;
              font-family: 'Poppins-SemiBold', sans-serif;
              margin: 0;
              padding: 0;
              p {
                margin: 0;
                padding: 0;
                line-height: 190%;
              }
            }
          }

          &.swiper-slide-prev, &.swiper-slide-next {
            opacity: 0 !important;
          }

          /deep/ &.swiper-slide-prev {
            opacity: 0;

            .swiper-slide-shadow-left, .swiper-slide-shadow-right {
              background: none !important;
              transition-duration: 0ms !important;
              border-radius: 2em;
              opacity: 0 !important;
              display: none !important;
            }
          }

          /deep/ &.swiper-slide-next {
            opacity: 0;

            .swiper-slide-shadow-left, .swiper-slide-shadow-right {
              background: none !important;
              transition-duration: 0ms !important;
              border-radius: 2em;
              opacity: 0 !important;
              display: none !important;
            }
          }
        }

        .swiper-pagination {
          /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
            background-color: white;
          }
        }

        .swiper-button-prev, .swiper-button-next {
          color: $primary;
        }

        @include xl {
          .swiper-button-prev {
            left: 15%;
          }

          .swiper-button-next {
            left: 85%;
          }

        }

        .swiper-button-next, .swiper-button-prev {
          background-color: $primary;
          width: 3em;
          height: 3em;
          border-radius: 100%;
          color: white;

          &::after {
            font-size: 1.25rem !important;
          }
        }
      }
    }

    &__info {
      margin: 65px 0;

      p {
        text-align: center;
        color: $dark;
        font-size: 1rem;
        font-family: 'Poppins-SemiBold', sans-serif;
        margin: 0;
        padding: 0;
        p {
          margin: 0;
          padding: 0;
          line-height: 190%;
        }
      }
    }

    .splash-2 {
      position: absolute;
      top: 140px;
      left: 0;
      background-image: url('../assets/splash_4.svg');
      height: 609px;
      background-repeat: no-repeat;
      z-index: -1;
      width: 726px;
      transform: translateX(-110%);
    }
  }

  .why-us {
    .why-us__content {
      display: grid;
      grid-template-columns: 100%;
      grid-template-areas: "why-us-left"
      "why-us-right";
      padding: 0 30px;
      @include xl {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-areas: "why-us-left why-us-right";
        padding: 0;
      }

      .content__left {
        grid-area: why-us-left;

        .left__title {
          background: url('../assets/question-mark.svg') no-repeat center;
          height: 200px;
          @include xl {
            height: 200px;
            margin: 65px 0;
          }
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .title--muted {
            color: $primary;
            font-size: 1.3rem;
            margin: 0;
            margin-top: 1em;
            padding: 0;
            font-family: 'Gilroy-Light', sans-serif;
            letter-spacing: 4px;
          }

          .title--heading {
            margin: 0;
            padding: 0;
            color: $dark;
            font-size: 2.8rem;
            font-family: 'Gilroy-ExtraBold', sans-serif;
            text-align: center;
          }
        }

        .left__info {
          margin: 65px 0;

          p {
            text-align: center;
            color: $dark;
            font-size: 1rem;
            font-family: 'Poppins-SemiBold', sans-serif;
            margin: 0 auto;
            padding: 0;
            max-width: 500px;
            p {
              margin: 0;
              padding: 0;
              line-height: 190%;
            }
          }
        }

        .left__yt {
          display: flex;
          justify-content: center;

          .yt__iframe {
            background: url('../assets/yt.png') no-repeat center;
            background-size: contain;
            width: 504px;
            height: 304px;
            transition: transform 0.3s;
            cursor: pointer;
            &:hover {
              transform: scale(1.1);
            }
          }

          div {
            iframe {
              max-width: 100%;
            }
          }
        }
      }

      .content__right {
        grid-area: why-us-right;
        position: relative;
        min-height: 400px;
        height: 100%;
        width: 100%;

        .yt__svg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          transform: scale(1.2);
          @include xl {
            transform: scale(1);
            top: 120px;
            height: 721px;
            width: 820px;
            left: 90px;
          }
          background: url('../assets/yt-right.png') no-repeat center;
          background-size: contain;
        }

        .splash-3 {
          display: none;
          @include xl {
            display: initial;
          }
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          @include xl {
            top: 159px;
            left: 170px;
            height: 1140px;
            width: 1330px;
          }
          .splash__wrapper {
            width: 100%;
            height: 100%;
            position: relative;
            .splash {
              background-image: url($assets + 'splash_5.png');
              background-repeat: no-repeat;
              width: 100%;
              height: 100%;
            }
          }
          z-index: -2;
        }
      }
    }
  }

  .join-us__bottom-wave {
    margin-top: -1px;
    border-width: 0;
    position: relative;
    font-size: 0;
    .splash {
      border-width: 0;
      font-size: 0;
    }
    .splash__right {
      font-size: 0;
      display: none;
      @include xl {
        top: -180%;
        right: -15%;
        display: initial;
      }
      background: url('../assets/influencers-splash-2.png');
      width: 517px;
      height: 1000px;
      position: absolute;
      @include xxl {
        top: -120%;
        right: -5%;
      }
      z-index: -1;
    }

    .splash__left {
      display: none;
      @include xl {
        top: -135%;
        left: -55%;
        display: initial;
      }
      transform: rotateY(-30%);
      background: url('../assets/influencers-splash-3.png');
      width: 2100px;
      height: 693px;
      position: absolute;
      @include xxl {
        top: -80%;
        left: -25%;
      }
      z-index: -1;
    }
  }

  .join-us__wave {
    margin-top: 3rem;
    .splash {
      margin: 0;
      padding: 0;
      font-size: 0;
    }

    .join-us__splash {
      position: relative;

      .splash__title {
        font-family: 'Gilroy-ExtraBold', sans-serif;
        color: #171717;
        width: 100%;
        height: 100px;
        text-align: center;
        font-size: 6rem;
        position: absolute;
        left: 0;
        top: -40%;
        @include md {
          top: 12%;
        }
        @include xl {
          font-size: 20rem;
          top: -17.5%;
        }
        margin: 0;
        padding: 0;
        z-index: 0;
      }
    }
  }

  .join-us {
    position: relative;
    background-color: #171717;

    &__arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      .arrow-wrapper__btn {
        background-color: white;
        color: #171717;
        margin-bottom: 2rem;
        transition: transform 0.3s;
        cursor: pointer;
        padding: 15px 25px;
        border: 2px solid #262626;
        border-radius: 4em;
        font-family: 'Gilroy-ExtraBold', sans-serif;
        font-size: 1.1rem;
        @include xl {
          font-size: 1.3rem;
        }
        @include xl {
          padding: 22px 52px;
        }
        &:hover {
          transform: scale(1.1);
        }
      }
      .arrow-wrapper__arrow {
        cursor: pointer;
        background: url('../assets/join-us-arrow.png') no-repeat center;
        background-position-y: 55%;
        width: 3rem;
        height: 3rem;
        border-radius: 100%;
        border: 1px solid #262626;
        transition: transform 0.3s;
        transform: translateY(10%);
        &:hover {
          border-color: $light;
        }
      }
    }
    .splash__title--light {
      display: none;
      @include xl {
        display: initial;
      }
      font-family: 'Gilroy-ExtraBold', sans-serif;
      width: 100%;
      margin: 0;
      text-align: center;
      font-size: 6rem;
      @include xl {
        font-size: 25rem;
      }
      position: absolute;
      left: 0;
      color: #1a1a1a;
      top: -40%;
      z-index: 0;
    }

    .join-us__title {
      position: relative;
      @include lg {
        padding-bottom: 2rem;
      }
      background: url('../assets/question-mark-dark.png') no-repeat center;
      background-position-y: 35px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 3;

      .title--heading {
        margin: 0;
        padding: 0;
        font-family: 'Gilroy-ExtraBold', sans-serif;
        font-size: 2rem;
        @include xl {
          font-size: 2.8rem;
        }
        text-align: center;
      }

      .title--subtitle {
        margin: 0;
        padding: 0;
        font-family: 'Gilroy-Light', sans-serif;
        font-size: 2rem;
        @include xl {
          font-size: 2.8rem;
        }
        text-align: center;
      }

      .title__icon {
        width: 127px;
        height: 72px;
        background: url('../assets/open-hands-icon.png') no-repeat center;
        margin-bottom: 2rem;
      }
    }

    .join-us__content {
      background-color: #171717;
      color: white;
      padding: 100px 0 0 0;
      position: relative;
      grid-template-rows: auto;

      .content__row {
        z-index: 3;
        position: relative;
        margin: 0 auto;
        max-width: 1569px;
        width: 100%;
        display: grid;
        grid-template-columns: 100%;
        @include xl {
          display: grid;
          grid-template-columns: 33.3% 33.3% 33.3%;
        }

        .row__col {
          padding: 0 30px;
          &:first-of-type {
            background: url('../assets/first.svg') no-repeat center 25%;
          }

          &:nth-of-type(2) {
            background: url('../assets/second.svg') no-repeat center 35%;
          }

          &:nth-of-type(3) {
            background: url('../assets/third.svg') no-repeat center 25%;
          }
          @include xl {
            padding: 0 30px;

            &:first-of-type {
              background: url('../assets/first.svg') no-repeat center 53%;
            }

            &:nth-of-type(2) {
              background: url('../assets/second.svg') no-repeat center 15%;
            }

            &:nth-of-type(3) {
              background: url('../assets/third.svg') no-repeat center 53%;
            }
          }

          .col__title {
            text-align: center;
            margin: 0;
            padding: 0;
            font-family: 'Gilroy-ExtraBold', sans-serif;
            font-size: 2rem;
            @include xl {
              font-size: 2.8rem;
            }
          }

          .col__content {
            margin: 30px 0;

            p {
              max-width: 330px;
              text-align: center;
              color: white;
              font-size: 1rem;
              font-family: 'Poppins-SemiBold', sans-serif;
              margin: 0 auto;
              padding: 0;
            }
          }

          @include xl {
            &:first-child {
              padding-top: 30%;
            }

            &:last-child {
              padding-top: 30%;
            }
          }

          .col__icon {
            margin-bottom: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;

            &--coffee {
              width: 75px;
              height: 71px;
              background: url('../assets/coffee-icon.png') no-repeat center;
            }

            &--trophy {
              width: 75px;
              height: 79px;
              background: url('../assets/trophy.png') no-repeat center;
            }

            &--brain {
              width: 82px;
              height: 70px;
              background: url('../assets/brain-icon.png') no-repeat center;
            }
          }
        }
      }
    }
  }

  .influencers {
    position: relative;
    .influencers-splash {
      display: none;
      @include xl {
        display: initial;
      }
      position: absolute;
      width: 464px;
      height: 762px;
      top: 200px;
      z-index: 0;
      left: 0;
      background: url('../assets/influencers-splash.svg') no-repeat;
      background-size: cover;
      background-position-x: 150%;
      @include xxl {
        background-position-x: 130%;
      }
    }

    &__title {
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .title--muted {
        color: $primary;
        font-size: 1.3rem;
        margin: 0;
        padding: 0;
        font-family: 'Gilroy-Light', sans-serif;
        letter-spacing: 4px;
      }

      .title--heading {
        margin: 0;
        padding: 0;
        color: $dark;
        font-size: 2.8rem;
        font-family: 'Gilroy-ExtraBold', sans-serif;
        text-align: center;
      }
    }

    &__slider {
      height: 400px;
      margin-top: 3em;
      position: relative;

      .influencers__swiper {
        height: 100%;
        width: 60%;
        margin: 0 auto;

        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 400px;
          width: 255px;
          text-align: center;
          font-weight: bold;
          font-size: 16 * 2;
          background-position: center;
          background-size: cover;
          color: white;

          .slider__slide {
            .slide__img {
              &--wg {
                height: 244px;
                width: 255px;
                background: url('../assets/influencer.png') no-repeat center;
              }
            }

            .slide__title {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              padding: 1rem;
              margin-top: 1rem;

              .title--heading {
                margin: 0;
                padding: 0;
                margin-bottom: 0.5rem;
                font-size: 1.25rem;
                color: $dark;
                font-family: 'Poppins Medium', sans-serif;
              }

              .title--muted {
                margin: 0;
                padding: 0;
                font-size: 1.25rem;
                color: $dark;
                font-family: 'Gilroy-ExtraBold', sans-serif;
              }
            }
          }
        }

        .swiper-pagination {
          /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
            background-color: white;
          }
        }

        .swiper-button-prev, .swiper-button-next {
          top: 266px;
          color: $primary;
        }

        .swiper-button-prev {
          background-color: $primary;
        }

        .swiper-button-next, .swiper-button-prev {
          background-color: $primary;
          width: 3em;
          height: 3em;
          border-radius: 100%;
          color: white;

          &::after {
            font-size: 1.25rem !important;
          }
        }

        /*<!--@include xxl {-->*/
        /*<!--  .swiper-button-prev {-->*/
        /*<!--    left: 244px;-->*/
        /*<!--  }-->*/

        /*<!--  .swiper-button-next {-->*/
        /*<!--    right: 244px;-->*/
        /*<!--  }-->*/
        /*<!--}-->*/
      }

      .slide__shadow {
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 267px;
        top: 0;
        left: 0;
        -webkit-box-shadow: inset 0px -200px 156px -51px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: inset 0px -200px 156px -51px rgba(0, 0, 0, 0.05);
        box-shadow: inset 0px -200px 156px -51px rgba(0, 0, 0, 0.05);
      }

      .slider__slide {
        .slide__img {
          height: 244px;
          width: 255px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .slide__title {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 1rem;
          margin-top: 1rem;

          .title--heading {
            margin: 0;
            padding: 0;
            margin-bottom: 0.5rem;
            font-size: 1.25rem;
            font-family: 'Poppins Medium', sans-serif;
          }

          .title--muted {
            margin: 0;
            padding: 0;
            font-size: 1.25rem;
            font-family: 'Gilroy-ExtraBold', sans-serif;
          }
        }
      }
    }

    &__info {
      margin: 0 auto;
      padding: 0 30px;
      @include xl {
        margin-top: 5rem;
      }
      max-width: 1569px;
      display: grid;
      grid-template-columns: 100%;
      @include xl {
        grid-template-columns: 1fr 1fr;
      }

      .info__projects {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 2.5rem;
        position: relative;
        z-index: 5;

        .projects__bg {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          @include lg {
            display: initial;
          }
          @include xxl {
            top: -10%;
            left: -15%;
          }
          z-index: 13;
          width: 400px;
          height: 280px;
          background: url('../assets/projects-count-bg.png');
          background-size: cover;
        }

        .projects__top-icons {
          display: none;
          @include xl {
            display: initial;
          }
          width: 205px;
          height: 77px;
          position: absolute;
          top: -5%;
          left: 50%;
          .top-icons {
            &__heart-left {
              top: 30%;
              left: 0;
              position: absolute;
              background: url('../assets/heart-top-left.png') no-repeat center;
              width: 21px;
              height: 19px;

              &--pulse {
                -webkit-animation: pulse-heart-left 2s cubic-bezier(.37,.29,.11,.92) infinite;
                animation: pulse-heart-left 2s cubic-bezier(.37,.29,.11,.92) infinite;
                @keyframes pulse-heart-left {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }

            &__heart-right {
              background: url('../assets/heart-top-right.png') no-repeat center;
              width: 26px;
              height: 24px;
              top: -15%;
              left: 75%;
              position: absolute;

              &--pulse {
                -webkit-animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 6s infinite;
                animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 6s infinite;
                @keyframes pulse-heart-right {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }

            &__like-left {
              background: url('../assets/like-top-left.png') no-repeat center;
              width: 17px;
              height: 17px;
              top: 58%;
              left: 35%;
              position: absolute;

              &--pulse {
                -webkit-animation: pulse-like-left 2s cubic-bezier(.37,.29,.11,.92) 1.5s infinite;
                animation: pulse-like-left 2s cubic-bezier(.37,.29,.11,.92) 1.5s infinite;
                @keyframes pulse-like-left {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }
            &__like-right {
              background: url('../assets/like-top-right.png') no-repeat center;
              width: 30px;
              height: 26px;
              top: 50%;
              left: 100%;
              position: absolute;

              &--pulse {
                -webkit-animation: pulse-like-right 2s cubic-bezier(.37,.29,.11,.92) 4.5s infinite;
                animation: pulse-like-right 2s cubic-bezier(.37,.29,.11,.92) 4.5s infinite;
                @keyframes pulse-like-right {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }
          }
        }

        .projects__bottom-icons {
          width: 109px;
          height: 51px;
          position: absolute;
          bottom: -5%;
          left: 65%;

          .bottom-icons {
            &__heart-right {
              background: url('../assets/heart-bottom-right.png') no-repeat center;
              width: 26px;
              height: 24px;
              top: -15%;
              left: 75%;
              position: absolute;

              &--pulse {
                -webkit-animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 5s infinite;
                animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 5s infinite;
                @keyframes pulse-heart-right {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }

            &__like-left {
              background: url('../assets/like-bottom-left.png') no-repeat center;
              width: 18px;
              height: 16px;
              top: 55%;
              left: 0;
              position: absolute;

              &--pulse {
                -webkit-animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 4s infinite;
                animation: pulse-heart-right 2s cubic-bezier(.37,.29,.11,.92) 4s infinite;
                @keyframes pulse-heart-right {
                  0% {
                    transform: scale(0.5);
                    opacity: 0;
                  }
                  50% {
                    opacity: 0.75;
                  }
                  70% {
                    opacity: 0.35;
                  }
                  100% {
                    transform: scale(1.1);
                    opacity: 0;
                  }
                }
              }
            }
          }
        }

        @include xxl {
          margin-bottom: 0;
          flex-direction: row;
        }

        .projects__count {
          position: relative;
          z-index: 14;
          font-family: 'Gilroy-ExtraBold', sans-serif;
          font-size: 7.5rem;
          color: $dark;
          margin: 0;
          padding: 0;
          @include xl {
            font-size: 11.43rem;
          }
        }

        .projects__title {
          position: relative;
          z-index: 14;
          font-family: 'Gilroy-ExtraBold', sans-serif;
          font-size: 2.3rem;
          @include xl {
            font-size: 2.81rem;
            text-align: left;
          }
          color: $dark;
          margin: 0;
          padding: 0;
          text-align: center;
          margin-bottom: 2rem;
          @include xxl {
            margin-left: 2rem;
            margin-top: 2.5rem;
            margin-bottom: 0;
          }
        }
      }

      .info__content {
        display: grid;
        grid-template-columns: 100%;
        @include xxl {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }

        .content__left {
          text-align: center;
          color: $dark;
          font-size: 1rem;
          font-family: 'Poppins-SemiBold', sans-serif;
          margin: 0;
          padding: 0;
          p {
            margin: 0;
            @include xxl {
              margin: 0 auto;
              max-width: 275px;
            }
            padding: 0;
            line-height: 190%;
          }
        }

        .content__right {
          text-align: center;
          color: $dark;
          font-size: 1rem;
          font-family: 'Poppins-SemiBold', sans-serif;
          margin: 0;
          padding: 0;
          p {
            margin: 0;
            @include xxl {
              margin: 0 auto;
              max-width: 275px;
            }
            padding: 0;
            line-height: 190%;
          }
          margin-top: 2rem;
          @include xl {
            margin-top: 0;
          }
        }
      }

      .hours {
        display: flex;
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
        flex-direction: column;
        position: relative;
        @include xl {
          display: none;
        }
        .hours__count {
          font-family: 'Gilroy-ExtraBold', sans-serif;
          font-size: 7.5rem;
          color: $primary;
          margin: 0;
          padding: 0;
          text-align: center;
        }

        .hours__title {
          font-size: 2.3rem;
          font-family: 'Gilroy-ExtraBold', sans-serif;
          color: $dark;
          margin: 0;
          padding: 0;
          text-align: center;
        }

        &__watch {
          width: 37px;
          height: 44px;
          position: absolute;
          bottom: -25%;
          right: 40%;
          z-index: 3;
          background: url('../assets/watch-icon.png') no-repeat center;
        }

        &__calendar {
          width: 37px;
          height: 44px;
          position: absolute;
          bottom: -35%;
          right: 15%;
          z-index: 3;
          background: url('../assets/calendar-icon.png') no-repeat center;
        }

        &__sandglass {
          width: 37px;
          height: 44px;
          position: absolute;
          bottom: 37%;
          right: 0;
          z-index: 3;
          background: url('../assets/sandglass-icon.png') no-repeat center;
        }

      }
    }
  }

  .footer {
    .splash {
      @include xl {
        margin-top: 3rem;
      }
      position: relative;

      .hours {
        display: none;
        @include xl {
          display: flex;
        }
        position: absolute;
        top: 0;
        left: 20%;
        @include xl {
          top: -15px;
          left: 25%;
        }
        @include xxl {
          left: 40%;
          top: 20px;
        }

        &__watch {
          width: 37px;
          height: 44px;
          position: absolute;
          top: -5%;
          left: 50%;
          z-index: 3;
          background: url('../assets/watch-icon.png') no-repeat center;
        }

        &__calendar {
          width: 37px;
          height: 44px;
          position: absolute;
          top: -15%;
          left: 63%;
          z-index: 3;
          background: url('../assets/calendar-icon.png') no-repeat center;
        }

        &__sandglass {
          width: 37px;
          height: 44px;
          position: absolute;
          top: 50%;
          right: 5%;
          z-index: 3;
          background: url('../assets/sandglass-icon.png') no-repeat center;
        }

        .hours__count {
          font-family: 'Gilroy-ExtraBold', sans-serif;
          font-size: 11.43rem;
          color: $primary;
          margin: 0;
          padding: 0;
          position: relative;
          z-index: 12;
        }

        .hours__count--bg {
          &--dark {
            mix-blend-mode: difference;
            position: absolute;
            left: -10%;
            color: transparent;
            font-family: 'Gilroy-ExtraBold', sans-serif;
            font-size: 15rem;
            -webkit-text-stroke: 1px #fafafa;
            opacity: .35;
          }
        }

        .hours__title {
          font-size: 2.8rem;
          font-family: 'Gilroy-ExtraBold', sans-serif;
          color: $dark;
          margin: 0;
          padding: 0;
          margin-top: 1.5rem;
          margin-left: 1.5rem;
          position: relative;
          z-index: 12;
        }
      }
    }
    .footer__content {
      background-color: #171717;
      padding-bottom: 4rem;
      width: 100%;
      height: auto;
      .content__row {
        padding: 0 30px;
        display: grid;
        grid-template-columns: 100%;
        @include xl {
          max-width: 1569px;
          width: 100%;
          padding: 0 0 6rem 0;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
        }
        .row__right {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 300px;
          width: 100%;
          height: 100%;
          .right__img {
            img {
              width: 100%;
              @include xl {
                width: 639px;
                height: 453px;
              }
            }
          }
        }

        .row__left {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          position: relative;
          z-index: 1;

          .left__wrapper {
            .left__smile {
              background: url('../assets/smile.png') no-repeat center;
              position: absolute;
              left: 10%;
              top: 0;
              z-index: -1;
              width: 194px;
              height: 358px;
            }

            .left--muted {
              color: $primary;
              font-family: 'Gilroy-Light', sans-serif;
              font-size: 1.3rem;
              margin: 0;
              padding: 0;
            }

            .left--heading {
              font-family: 'Gilroy-ExtraBold', sans-serif;
              color: white;
              font-size: 2.85rem;
              margin: 0;
              padding: 0;
            }

            .left__contact {
              margin: 3rem 0 3rem 0;
              color: white;
              font-family: 'Gilroy-ExtraBold', sans-serif;
              font-size: 1.56rem;
              line-height: 180%;

              .contact--primary {
                width: 8rem;
                display: inline-block;
                color: $primary;
              }
            }

            .left__social-media {
              display: grid;
              /*grid-column-gap: 1rem;*/
              grid-template-columns: .25fr .25fr .25fr .25fr;
              .social-media__icon {
                cursor: pointer;
                border: 0;
                width: 4rem;
                height: 4rem;
                border-radius: 100%;
                background-color: $light;
                transition: all 0.3s;

                svg {
                  vertical-align: -0.250em;
                  width: 1.3rem;
                  height: 2rem;
                }

                &:hover {
                  background-color: #fe3c53;
                  transform: scale(1.1);
                }
              }
            }

            .left__messenger {
              margin-top: 3rem;
              width: 100%;
              border-radius: 4rem;
              background-color: #18b7ff;
              color: white;
              font-family: 'Gilroy-ExtraBold', sans-serif;
              text-align: center;
              padding: 1rem 0;
              letter-spacing: 3px;
              cursor: pointer;
              transition: transform 0.3s;

              &:hover {
                transform: scale(1.1);
              }

              &--pulse {
                -webkit-animation: pulse-msg 2s cubic-bezier(.37,.29,.11,.92) infinite;
                animation: pulse-msg 2s cubic-bezier(.37,.29,.11,.92) infinite;
                @keyframes pulse-msg {
                  0% {
                    box-shadow: 0 0 0 0 rgba(24,183,255,.3);
                  }
                  100% {
                    box-shadow: 0 0 0 25px rgba(24,183,255,0);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .swiper-button-next, ::v-deep .swiper-button-prev {
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.1);
    }
  }
</style>
